import styled from "styled-components";
import { PRIMARY } from "../const/colors";

const NavIcon = styled.div.attrs((props) => ({
  className: props.className,
}))`
  width: 30px;
  height: 30px;
  position: relative;
  transition: 0.1s;
  margin: 10px 10px;
  cursor: pointer;
  display: inline-block;
  margin: 5px;
  span {
    width: 7px;
    height: 7px;
    background-color: ${PRIMARY};
    display: block;
    position: absolute;
  }
  &:hover span {
    transform: scale(1.2);
    transition: 350ms cubic-bezier(0.8, 0.5, 0.2, 1.4);
  }
  span:nth-child(1) {
    left: 0;
    top: 0;
  }
  span:nth-child(2) {
    left: 12px;
    top: 0;
  }
  span:nth-child(3) {
    right: 0;
    top: 0;
  }
  span:nth-child(4) {
    left: 0;
    top: 12px;
  }
  span:nth-child(5) {
    position: absolute;
    left: 12px;
    top: 12px;
  }
  span:nth-child(6) {
    right: 0px;
    top: 12px;
  }
  span:nth-child(7) {
    left: 0px;
    bottom: 0px;
  }
  span:nth-child(8) {
    position: absolute;
    left: 12px;
    bottom: 0px;
  }
  span:nth-child(9) {
    right: 0px;
    bottom: 0px;
  }
  &.open {
    transform: rotate(45deg);
    cursor: pointer;
    transition: 0.2s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  }
  &.open span {
    transition-delay: 200ms;
    transition: 0.5s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  }

  &.open span:nth-child(1),
  &.open span:nth-child(3),
  &.open span:nth-child(7),
  &.open span:nth-child(9) {
    opacity: 0;
  }
`;

const MenuIcon = ({ clicked, handleClick }) => {
  return (
    <NavIcon onClick={handleClick} className={clicked ? "open" : ""}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </NavIcon>
  );
};

export default MenuIcon;
